import styled from 'styled-components';

export const ContainerRequestedBy = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
`;

export const TextPendingApproval = styled.p`
  text-transform: uppercase;
  color: #C37C4A;
  margin-left: 5px;
`;

export const RequestedBy = styled.span`
  color: #FF5555;
  margin-left: 3px;
  font-weight: 500;
`;
